module.exports = __webpack_public_path__ + "media/assets/images/icons/patient-page/Vector-5a7230faaa646687d53f22af0754afbd.svg";